export class IdModel {
    id:number;
    shipmentStatusId: number = null;
    cols:string;
    shipmentIds: number[];
    isHideInPackage: boolean;
    pageSize: number = 20;
    pageNumber: number = 1;
}